import React, { Component } from 'react';
import HeaderComponent from './../components/header';
import { startTutorial, stopTutorial, endTutorial, addStepsToTutorial } from '../actions/tutorial';
import { tutorialSequence } from './../constants/tutorialSequence';
import { connect } from 'react-redux';
import * as initActions from './../actions/init';

class HeaderContainer extends Component {
    componentDidMount() {
        this.props.listenWindow();
        // if (!this.props.tutorial.isRunning) {
        //     startTutorial();
        //     console.log('?');

        //     addStepsToTutorial(tutorialSequence);
        // }
    }

    render() {
        const { timeData, uiState, actors } = this.props;
        return <HeaderComponent
            actors={actors}
            timeData={timeData}
            uiState={uiState}
            logoutType={this.props.uiState.user.logoutType}
            openHelpMenu={this.props.openHelpMenu}
            closeHelpMenu={this.props.closeHelpMenu}
        />;
    }
}


const mapStatetoProps = (state) => {
    return state;
};

export default connect(mapStatetoProps, { ...initActions })(HeaderContainer);


// WEBPACK FOOTER //
// /src/containers/HeaderContainer.js